import { ReactNode, createContext, useContext } from 'react';
import { noop } from '../../utils/noop';

export interface ServiceContext {
  open: (body: ReactNode) => Promise<void>;
  close: () => void;
}

export const ConfirmDialogContext = createContext<ServiceContext>({
  open: async () => {},
  close: noop,
});

export const useConfirmDialog = (): ServiceContext =>
  useContext(ConfirmDialogContext);
